// extracted by mini-css-extract-plugin
export default {"erroricon":"CheckoutProcessingTerminalPaymentView_erroricon__CsPfg"};